// アンカーリンクスクロール設定
const [ w, d, l ] = [ window, document, location ]
const mq = w.matchMedia('screen and (max-width: 780px)');

const anchorClick = (e,offsetFlg) => {
  const $this = $(e.currentTarget).addClass('clicked')
  var path = $this.attr('href').match(/^([^#]+)(#.*)?/) || [];
  if (path[1] === l.pathname + l.search) {
    e.preventDefault();
    $this.attr('href', path[2]);
  }
  if(mq.matches) offsetFlg = false
  let speed = 500,
      href = $this.attr('href'),
      $target = $(href == '#pagetop' || href == '#top' ? 'html' : href),
      offset = (offsetFlg)? $('.p-header').innerHeight(): 0,
      pos = $target.offset().top - parseInt(offset)
  $('body,html').animate({
    scrollTop: pos
  }, speed, 'easeInOutExpo', function () {
    setTimeout(function () {
      $this.removeClass('clicked');
    }, 1000);
  });
  if (href != '#pagetop' && href != '#top' && href != '#contents')
    window.history.pushState(null, null, e.currentTarget.hash);
  return false;
}

const anchorDefault = offsetFlg => {
  if(!l.hash) return false
  if(mq.matches) offsetFlg = false
  let pos = $(l.hash).offset().top
  let offset = ( offsetFlg )? $('.p-header').innerHeight(): 0
  pos = ( pos - parseInt( offset ) )
  $('body,html').animate({scrollTop: pos}, 200, 'easeInOutExpo');
}

export default function PAGESCROLL (offset=true){
  w.addEventListener('load',() => anchorDefault(offset) )
  $(d).on('click', 'a[href^="#"],a[href*="#"]', (e) => anchorClick(e,offset) )
}